<template>
  <form @submit.prevent="save">
    <template v-if="securities.length">
      <base-table>
        <thead>
          <tr>
            <th>Security</th>
            <th>Charge</th>
            <th>Value</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in Object.keys(securities)" :key="i">
            <td>
              <template v-if="isEditing(securities[i])">
                <base-input v-model="editing.name" placeholder="name" required />
              </template>
              <template v-else>
                {{ securities[i].name }}
              </template>
            </td>
            <td>
              <template v-if="isEditing(securities[i])">
                <base-select v-model="editing.charge" placeholder="charge" source="securityCharges" required />
              </template>
              <template v-else>
                {{ securities[i].charge }}
              </template>
            </td>
            <td>
              <template v-if="isEditing(securities[i])">
                <base-field addon-left-icon="pound-sign" row>
                  <base-input v-model="editing.amount" numeric placeholder="amount" required />
                </base-field>
              </template>
              <template v-else>
                {{ $formatting.toCurrency(securities[i].amount) }}
              </template>
            </td>
            <td class="text-right">
              <template v-if="isEditing(securities[i])">
                <div class="btn-group">
                  <base-button primary small submit>
                    Save
                  </base-button>
                  <base-button v-tooltip="'Cancel'" icon-right="times" small @click="editing = null" />
                </div>
              </template>
              <template v-else>
                <div class="btn-group">
                  <base-button v-tooltip="'Edit'" icon-right="pencil-alt" prevent-default small @click="setEditing(securities[i])" />
                  <base-button v-tooltip="'Delete'" icon-right="trash" small @click="remove(i)" />
                </div>
              </template>
            </td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <div class="p-4 text-center">
        No securities have been added yet.
      </div>
    </template>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SecuritiesTable',

  props: {
    noRemove: Boolean,
    noSave: Boolean,
    value: Array
  },

  created () {
    this.securities = this.value
  },

  data () {
    return {
      editing: null,
      securities: []
    }
  },

  computed: {
    ...mapState({
      project: store => store.core.projects.entity
    })
  },

  methods: {
    isEditing (security) {
      if (this.$_.isObject(this.editing) && this.editing._id === security._id) {
        return true
      }

      return false
    },

    setEditing (security) {
      this.editing = this.$_.clone(security)
    },

    async remove (index) {
      if (!confirm('Are you sure you want to delete this security?')) return

      const security = this.securities[index]

      if (this.noRemove) {
        this.$emit('removing', security)
      } else {
        await this.$store.dispatch('core/securities/remove', security._id)
      }

      this.securities.splice(index, 1)

      this.$emit('remove', security)
      this.$emit('input', this.securities)
    },

    async save () {
      const payload = this.editing

      if (this.noSave) {
        this.$emit('submitted', payload)
      } else {
        await this.$store.dispatch('core/securities/save', this.editing)
      }

      this.securities.filter((security, i) => {
        if (security._id === this.editing._id) {
          this.securities[i] = this.editing
        }
      })

      this.updateProject({
        _id: this.project._id,
        securities: this.$_.cloneDeep(this.securities)
      })

      this.$emit('input', this.securities)
      this.$emit('updated', this.editing)

      this.editing = null

      this.$flash.success('Security updated.')
    },

    ...mapActions({
      updateProject: 'core/projects/update'
    })
  }
}
</script>
